import { render, staticRenderFns } from "./accountpreviewComponent.vue?vue&type=template&id=675e6cd8&scoped=true"
import script from "./accountpreviewComponent.vue?vue&type=script&lang=js"
export * from "./accountpreviewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675e6cd8",
  null
  
)

export default component.exports